import { render, staticRenderFns } from "./comment-communiquer-efficacement-avec-google-ads.vue?vue&type=template&id=bc3b688a&"
import script from "./comment-communiquer-efficacement-avec-google-ads.vue?vue&type=script&lang=js&"
export * from "./comment-communiquer-efficacement-avec-google-ads.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports